<template>
  <b-container fluid>
    <div class="row">
      <div class="col-md-6 mx-auto mt-5">
        <div class="iq-card p-4">
          <div class="content">
            <div><img style="width:100%;" src="../../assets_gide/img/img/thank-you-card.jpg"/></div>
            <h1>{{ title }}</h1>
              <p class="mt-2" v-html="message"></p>
              <span v-if="message2" class="mt-4"><p class="mt-2" v-html="message2"></p></span>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { socialvue } from "../../config/pluginInit"
export default {
  name: "ThankYouPage",
  props: {
    propRedirect: {
      type: String,
      default: null
    }
  },
  data: () => ({
    title: "Thank You",
    message: `Thank you for your participation`,
    message2: ""
  }),
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  mounted () {
    socialvue.index()
    let code = this.$route.query.code ? this.$route.query.code : ""
    let redirectURL = this.propRedirect ? this.propRedirect : this.$route?.query?.redirect

    if (redirectURL) {
      redirectURL = atob(redirectURL)
      this.message2 = `You will redirected automatically to another link or <a href="${redirectURL}">Click here</a> to open the link`

      setTimeout(() => {
        window.open(redirectURL)
      }, 3000)
    }

    switch (code) {
      case "GPATHS_THANK_YOU":
        this.title = ""
        this.message = "We genuinely appreciate your time and openness in sharing your thoughts. Your feedback contributes to the ongoing improvement of GPaths, ensuring it remains a valuable resource for students navigating their career journeys. Thank you for being a part of the GIDE community!"
        break
      case "AP":
        this.title = "Thank you for completing your Mock Assessment"
        this.message = "Your results will be available within 48 hours. Check back soon to review your score and performance."
        break

      default:
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.content h1{
  font-weight: 600;
  font-size: 37px;
  text-align: center;
}

p{
  text-align: center;
  color: var(--iq-title-text);
  font-size: 14px;
  font-weight: 500;
}
.container-fluid{
  position: absolute;
  right: 0px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
  height: max-content;
}
@media screen and (min-width: 1200px) {
  .container-fluid{
    padding-left: 230px !important;
  }
}
</style>
